import { Dispatch } from "redux";
import { AxiosInstance } from "axios";
import { showNotification } from "../../notification/actions";
import routing from "../../../routing";

import { GET_TEACHER } from "../types";
import { TeacherActionTypes } from "../models/teacherActions";
import { ITeacherState } from "../models/interfaces";
import { IStateTree } from "../../interfaces";

export default (path: string) => async (dispatch: Dispatch<TeacherActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    let username = path.slice(routing.teacher.length + 2);
    dispatch({
        type: GET_TEACHER,
        payload: null,
    });
    try {
        const { data } = await api.get<ITeacherState>(`/teacher-page?username=${username}`);
        dispatch({
            type: GET_TEACHER,
            payload: data,
        });
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
    }
};
